import moment from 'moment'
import { get } from 'lodash'
import { AWARD_LEVELS, AJ_MIN_DATES } from '../constants/enums'

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()

import { getRegistrationAgeKeys } from '../helpers/getConfigKeys'

const isEmpty = value => value === undefined || value === null || value === ''
const isPhoneEmpty = value =>
  value === undefined || value === null || value === '' || value === '+'
const join = rules => (value, data) =>
  rules.map(rule => rule(value, data)).filter(error => Boolean(error))[0]

const checkEmail = value => {
  return !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(    value
  )
}

const checkPasswordStrength = value => {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/.test(value)
}

export function phone(value = '') {
  let isValid = true

  if (isEmpty(value)) {
    return
  }

  value = value.replace(/[^0-9]/g, '')
  value = `+${value}`

  try {
    value = phoneUtil.parse(value, '')
    isValid = phoneUtil.isValidNumber(value)
    if (!isValid) {
      return {
        text: 'Invalid phone format',
        intlKey: 'errors.invalid_phone_format',
        values: {}
      }
    }
  } catch (e) {
    return {
      text: 'Invalid phone format',
      intlKey: 'errors.invalid_phone_format',
      values: {}
    }
  }
}

export function email(value) {
  if (!isEmpty(value) && checkEmail(value)) {
    return {
      text: 'Invalid email address',
      intlKey: 'errors.invalid_email_address',
      values: {}
    }
  }
}
export function emailsDiffer(value, otherValues) {
  if (!isEmpty(value) && otherValues.some(v => (v === value))) {
    return {
      text: 'Emails cannot match',
      intlKey: 'errors.emails_cannot_match',
      values: {}
    }
  }
}

export function isEmail(value) {
  return isEmpty(value) || checkEmail(value)
}


export function required(value) {
  if (isEmpty(value) || (typeof value === 'string' && !value.trim())) {
    return {
      text: 'Required field',
      intlKey: 'errors.required_field',
      values: {}
    }
  }
}



export function requiredFutureDate(value) {
  const requiredError = required(value)

  if (requiredError) {
    return requiredError
  }
  if (!(new Date(value) > new Date())) {
    return {
      text: 'Must be a future date',
      intlKey: 'errors.future_date',
      values: {}
    }
  }
}

export function forbiddenFutureDate(value) {
  const requiredError = required(value)

  if (requiredError) {
    return requiredError
  }

  const startDate = new Date(value)
  startDate.setHours(0,0,0,0)
  const today = new Date()
  today.setHours(23,59,59,59)

  if (startDate > today) {
    return {
      text: 'Date of the last log cannot be in the future',
      intlKey: 'errors.date_last_log_cannot_be_in_future',
      values: {}
    }
  }
}

export function moreThan(limit) {
  return value => {
    if (value <= limit) {
      return {
        text: 'More than {limit}',
        intlKey: 'errors.more_than',
        values: {
          limit
        }
      }
    }
  }
}

export function logMinDuration(limit) {
  return value => {
    if (value < limit) {
      return {
        text: 'Minimal duration is {limit} min',
        intlKey: 'errors.log_longer_than',
        values: {
          limit
        }
      }
    }
  }
}

export function requiredCheck(value) {
  if (!value) {
    return {
      text: 'Required field',
      intlKey: 'errors.required_field',
      values: {}
    }
  }
}

export function requiredPhone(value) {
  if (isPhoneEmpty(value)) {
    return {
      text: 'Required field',
      intlKey: 'errors.required_field',
      values: {}
    }
  }
}

export function minLength(min) {
  return value => {
    if (!isEmpty(value) && value.length < min) {
      return {
        text: 'Must be at least {min} characters',
        intlKey: 'errors.must_be_at_least',
        values: { min }
      }
    }
  }
}

export function maxLength(max) {
  return value => {
    if (!isEmpty(value) && value.length > max) {
      return {
        text: 'Must be no more than {max} characters',
        intlKey: 'errors.must_be_no_more_than',
        values: { max }
      }
    }
  }
}

export function integer(value) {
  if (!Number.isInteger(Number(value))) {
    return {
      text: 'Must be an integer',
      intlKey: 'errors.must_be_an_integer',
      values: {}
    }
  }
}

export function hasNumbers(value) {
  if (!/\d/.test(value)) {
    return {
      text: 'Must contain at least one number',
      intlKey: 'errors.must_contain_at_least',
      values: {}
    }
  }
}

export function hasEmojis(value) {
  if (
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g.test(
      value
    )
  ) {
    return {
      text: 'This field cannot contain emojis',
      intlKey: 'errors.no_emojis',
      values: {}
    }
  }
}

export function hasUpperLowerCase(value) {
  if (!/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
    return {
      text: 'Must include at least one upper case characters',
      intlKey: 'errors.must_include_at_least',
      values: {}
    }
  }
}

export function hasSpecialCharacters(value, passwordSpecChars) {
  // eslint-disable-next-line no-control-regex
  let escaped = passwordSpecChars.replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0').replace(/[\/]/g, '\\/').replace(/[\]]/g, '\\]')

  let regex = new RegExp('[' + escaped + ']')

  if (!regex.test(value)) {
    return {
      text: 'Must include at least one upper case characters',
      intlKey: 'errors.include_at_least_one_special_char',
      values: {}
    }
  }
}

export function dateNotNull(value) {
  // react-dates unfortunately returns null when there's invalid value
  if (value === null) {
    return {
      text: 'Invalid date format',
      intlKey: 'errors.invalid_date_format',
      values: {}
    }
  }
}

export function oneOf(enumeration) {
  return value => {
    if (enumeration.indexOf(value) !== -1) {
      return {
        text: 'Must be one of: {enums}',
        intlKey: 'errors.must_be_one_of',
        values: { enums: enumeration.join(', ') }
      }
    }
  }
}

export function match(field) {
  return (value, data) => {
    if (data) {
      if (value !== data[field]) {
        return {
          text: 'Do not match',
          intlKey: 'errors.do_not_match'
        }
      }
    }
  }
}

export function minAge(value, minAge) {
  const age = moment().diff(value, 'years')

  if (age < minAge) {
    return {
      text: 'Min age is {age}',
      intlKey: 'errors.min_age',
      values: { age: minAge }
    }
  }
}

export function checkAwardLeaderMinAge(birthDate, minAge){

  const from = {
    years: Math.floor(minAge / 12),
    months: minAge / 12 % 1 * 12
  }

  const fromVal = from.years * 12 + from.months
  const diffFrom = moment().subtract(fromVal, 'month').diff(birthDate)

  if (diffFrom < 0) {
    return {
      text: 'Award leader must be older than {years} years and {months} months.',
      intlKey: 'errors.al_must_be_older_than',
      values: {
        years: from.years,
        months: from.months === 0 ? '0' : from.months
      }
    }
  }
}

export function ageBetween(
  value,
  awardLevel,
  options = { configuration: {}, awardConfigurations: [] }
) {
  const selectAwardConfiguration = options.awardConfigurations.filter(
    item => item.awardLevelType.value === awardLevel
  )[0]

  const configKeys = getRegistrationAgeKeys(awardLevel)
  let minMonths =
    get(options, `configuration[${configKeys.min}].intValue`) || 165
  let maxMonths =
    get(options, `configuration[${configKeys.max}].intValue`) || 294

  if (get(selectAwardConfiguration, 'maximumAgeMonths')) {
    maxMonths = selectAwardConfiguration.maximumAgeMonths
  }

  if (get(selectAwardConfiguration, 'minimumAgeMonths')) {
    minMonths = selectAwardConfiguration.minimumAgeMonths
  }

  const from = {
    years: Math.floor(minMonths / 12),
    months: minMonths / 12 % 1 * 12
  }
  const to = {
    years: Math.floor(maxMonths / 12),
    months: maxMonths / 12 % 1 * 12
  }

  const fromVal = from.years * 12 + from.months
  const toVal = to.years * 12 + to.months
  const diffFrom = moment().subtract(fromVal, 'month').diff(value)
  const diffTo = moment().subtract(toVal, 'month').diff(value)

  if (diffTo > 0) {
    return {
      text: 'You must be younger than {years} years and {months} months to register for the Award. Please speak with your Award Unit Staff about this.',
      intlKey: 'errors.you_must_be_younger_than',
      values: {
        years: to.years,
        months: to.months === 0 ? '0' : to.months
      }
    }
  }
  if (diffFrom < 0) {
    return {
      text: 'You must be older than {years} years and {months} months to register for the Award. Please speak with your Award Unit Staff about this.',
      intlKey: 'errors.you_must_be_older_than',
      values: {
        years: from.years,
        months: from.months === 0 ? '0' : from.months
      }
    }
  }
}

export function ageByConfig(value, options = {}) {
  const minMonths =
    get(options, `configuration[${options.leaderMinAge}].intValue`) || 216

  const from = {
    years: Math.floor(minMonths / 12),
    months: minMonths / 12 % 1 * 12
  }
  const fromVal = from.years * 12 + from.months

  const diffFrom = moment().subtract(fromVal, 'month').diff(value)

  if (diffFrom < 0) {
    return {
      text: 'You must be older than {years} years and {months} months to register as Award Leader.',
      intlKey: 'errors.you_must_be_older_than_register_for_leader',
      values: {
        years: from.years,
        months: from.months === 0 ? '0' : Math.ceil(from.months)
      }
    }
  }
}

export function minNights(startDate, endDate, options = {}) {
  const nights = moment(endDate).diff(startDate, 'days')

  switch (get(options, 'awardLevelValue')) {
    case AWARD_LEVELS.gold.id:
      if (AJ_MIN_DATES.gold.nights > nights) {
        return {
          text: 'A minimum of {nights} nights is required',
          intlKey: 'errors.min_nights_required',
          values: {
            nights: AJ_MIN_DATES.gold.nights
          }
        }
      }
      break
    case AWARD_LEVELS.silver.id:
      if (AJ_MIN_DATES.silver.nights > nights) {
        return {
          text: 'A minimum of {nights} nights is required',
          intlKey: 'errors.min_nights_required',
          values: {
            nights: AJ_MIN_DATES.silver.nights
          }
        }
      }
      break
    case AWARD_LEVELS.bronze.id:
      if (AJ_MIN_DATES.bronze.nights > nights) {
        return {
          text: 'A minimum of {nights} nights is required',
          intlKey: 'errors.min_nights_required',
          values: {
            nights: AJ_MIN_DATES.bronze.nights
          }
        }
      }
      break

    default:
  }
}

export function createValidator(rules) {
  return (data = {}) => {
    const errors = {}

    Object.keys(rules).forEach(key => {
      // concat enables both functions and arrays of functions
      const rule = join([].concat(rules[key]))
      const error = rule(data[key], data)

      if (error) {
        errors[key] = error
      }
    })
    return errors
  }
}

export function emailOrPhoneRequired(email, phone) {
  const empty = value =>
    isEmpty(value) || (typeof value === 'string' && !value.trim())

  if (empty(email) && empty(phone)) {
    return {
      text: 'Email or phone is required',
      intlKey: 'errors.email_or_phone_required',
      values: {}
    }
  }
}
